import React from "react";
import { Topbar } from "@components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { PRIVATE_ROUTE, } from '@router/route.constants';
import { useSelector } from "react-redux";
import { AuthLogo } from '@assets';

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

export const Logo = styled(AuthLogo)`
  margin: 0 auto;
 width: 100%;
`

const Title = styled.div`
padding-top: 6px;
padding-bottom: 16px;
  color: #006400;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px; /* 141.667% */
`;

const Rules = styled.div`
padding: 0 16px;
  color: #4F4F4F;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  user-select: none; /* Disable text selection */
  -webkit-user-select: none; /* For Safari */
  -moz-user-select: none; /* For Firefox */
  -ms-user-select: none; /* For Internet Explorer/Edge */
  -webkit-touch-callout: none; /* Disable context menu on touch devices */
  -moz-touch-callout: none;
  -ms-touch-callout: none;
  -webkit-touch-callout: none;

  ul {
    padding-inline-start: 0 !important;
  }
`;

const PromoTerms = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const { promocode_rule } = useSelector((state) => state.app.settings);

  const rule =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? promocode_rule?.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? promocode_rule?.text_mm
        : promocode_rule?.text_ch;

  const goBack = () => {
    navigate(`/${PRIVATE_ROUTE.PROMO_CODE_HISTORY}`);
  };

  return (
    <>
      <Topbar title={t("common.termsAndConditions")} goBack={goBack} />
      <RootContainer>
        <Logo />
        <Title > {t("common.termsAndConditions")} </Title>
        <Rules dangerouslySetInnerHTML={{ __html: rule }} />
      </RootContainer>
    </>
  );
};

export default PromoTerms;
